import React from 'react';
import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';
import classnames from 'classnames';
import { Row, Col } from 'react-flexbox-grid';
import styles from './Members.styl';
import Person from '../person/Person';
import PersonButton from '../person/PersonButton';

let colors = ['#8C8FE3', '#7796E3', '#6FACE4'];

function isInArray(value, array) {
  return array.indexOf(value) > -1;
}

const Member = props => {
  return (
    <div
      className={
        props.contactType === 'call' || props.contactType === 'email'
          ? ''
          : styles.wrapper
      }
    >
      {props.contactType === 'call' || props.contactType === 'email'
        ? <MediaQuery maxDeviceWidth={767}>
          <Row center="xs" className={styles.personButtonWrapper} style={{marginBottom: props.contactType === 'email' ? '0px' : '100px'}}>
            {props.members.map((member, i) => {
              return(
                <Col xs={10} key={i}>
                <PersonButton
                  index={i}
                  member={member}
                  color={colors[i]}
                  setSelectedMembers={props.setSelectedMembers}
                  contactType={props.contactType}
                  selected={isInArray(i, props.selectedMembers)}
                />
                </Col>
              )})}
              </Row>
          </MediaQuery>

        : ''}
      <Row className={classnames(styles.membersRow, styles[props.contactType])}>
        {props.members.map((member, i) => {
          return (
            <Col xs={12} sm={4} key={i}>
              <Person
                index={i}
                member={member}
                color={colors[i]}
                setContactType={props.setContactType}
                setSelectedMembers={props.setSelectedMembers}
                contactType={props.contactType}
                selected={isInArray(i, props.selectedMembers)}
                emailed={isInArray(i, props.emailedMembers)}
                called={isInArray(i, props.calledMembers)}
              />
            </Col>
          );
        })}
      </Row>
    </div>
  );
};

Member.propTypes = {
  members: PropTypes.array.isRequired
};

export default Member;



// WEBPACK FOOTER //
// ./src/components/members/Members.js